import { Component, inject } from '@angular/core';
import {
 UntypedFormArray, UntypedFormBuilder, UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule
} from '@angular/forms';
import {
 MAT_DIALOG_DATA, MatDialogRef, MatDialogTitle, MatDialogContent, MatDialogActions
} from '@angular/material/dialog';
import { ProcessingQuery, ProcessingQueryResult } from '@fairandsmart/types';
import { EMPTY } from 'rxjs';
import { catchError, finalize, tap } from 'rxjs/operators';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatFormField } from '@angular/material/form-field';
import { MatInput, MatInputModule } from '@angular/material/input';
import { MatButton } from '@angular/material/button';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatList, MatListItem } from '@angular/material/list';
import { MatChipListbox, MatChipOption } from '@angular/material/chips';
import { DatePipe } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';
import { ProcessingService } from '../processing.service';

@Component({
    selector: 'fs-processing-request-dialog',
    templateUrl: './processing-query-dialog.component.html',
    styleUrls: ['./processing-query-dialog.component.scss'],
    imports: [MatDialogTitle, FormsModule, ReactiveFormsModule, CdkScrollable, MatDialogContent, MatFormField, MatInput, MatButton, MatProgressSpinner, MatList, MatListItem, MatChipListbox, MatChipOption, MatDialogActions, DatePipe, TranslatePipe, MatInputModule]
})
export class ProcessingQueryDialogComponent {
  private readonly dialogRef = inject<MatDialogRef<ProcessingQueryDialogComponent, void>>(MatDialogRef);

  data = inject<{
    service: ProcessingService;
    orgaid: string;
    key: string;
}>(MAT_DIALOG_DATA);

  private readonly fb = inject(UntypedFormBuilder);

  public form: UntypedFormGroup;

  public attributes: UntypedFormArray;

  public result: ProcessingQueryResult;

  public loading: boolean;

  constructor() {
    this.form = this.fb.group({
      organisationId: [{ value: this.data.orgaid, disabled: true }, Validators.required],
      processingKey: [this.data.key, Validators.required],
      userId: ['', Validators.required],
      date: [''],
    });
    this.attributes = this.fb.array([]);
    this.addAttribute();
    this.loading = false;
  }

  addAttribute(): void {
    this.attributes.push(
      this.fb.group({
        key: [''],
        value: [''],
      }),
    );
  }

  removeAttribute(index: number): void {
    this.attributes.removeAt(index);
  }

  submit(): void {
    if (this.form.valid) {
      this.loading = true;
      const query: ProcessingQuery = this.form.getRawValue();
      query.attributes = this.transformFormArrayIntoMap(this.attributes);
      this.data.service.queryProcessings(query).pipe(
        tap((queryResult: ProcessingQueryResult) => {
          this.result = queryResult;
        }),
        catchError(() => EMPTY), // handle error translation ? was "this.alert.apiError(response.error, `${this.I18N_BASE}.ERROR.LOAD`);"
        finalize(() => {
          this.loading = false;
        }),
      ).subscribe();
    }
  }

  close(): void {
    this.dialogRef.close();
  }

  private transformFormArrayIntoMap(formArray: UntypedFormArray): { [key: string]: string } {
    return (formArray.value as { key: string, value: string }[])
      .reduce<{ [key: string]: string }>((previousValue, currentValue) => {
      if (currentValue.key?.length > 0) {
        previousValue[currentValue.key] = currentValue.value;
      }
      return previousValue;
    }, {});
  }
}
